import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import _ from "lodash";
import CustomPaper from "../../../components/CustomPaper";
import Grid from "@material-ui/core/Grid";
import Image from "../../../../assets";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../components/CustomText";
import Files from "react-butterfiles";
import Color from "../../../../utils/Color";

const OpenFile = ({ classes, onSuccess, onError, type, isLogin }) => {
  const [isHoverFront, setIsHoverFront] = useState(false);
  const [isHoverBack, setIsHoverBack] = useState(false);

  const mouseOver = () => {
    if (type === "front") {
      setIsHoverFront(!isHoverFront);
    } else {
      setIsHoverBack(!isHoverBack);
    }
  };

  return (
    <Files
      multiple={false}
      maxSize="10mb"
      multipleMaxSize="10mb"
      multipleMaxCount={1}
      accept={["application/pdf", "image/jpg", "image/jpeg"]}
      onSuccess={(files) => onSuccess(files, type)}
      onError={(errors) => onError(errors[0].type)}
      convertToBase64={true}
    >
      {({ browseFiles, getDropZoneProps }) => (
        <CustomPaper
          design={
            isLogin
              ? classes.notUploadNRICPaperisLogin
              : classes.notUploadNRICPaper
          }
          onClick={browseFiles}
          onMouseOver={mouseOver}
          onMouseOut={mouseOver}
          {...getDropZoneProps()}
        >
          <Grid
            container
            direction={"column"}
            justify={"center"}
            alignItems={"center"}
          >
            <Grid item>
              <div style={{ display: "flex", alignItems: "center" }}>
                {console.warn("mouseOver", mouseOver)}
                {isLogin ? (
                  <img
                    src={
                      isHoverFront || isHoverBack
                        ? Image.uploadAttachFileIconHover
                        : Image.uploadAttachFileIcon
                    }
                    // style={{ filter: isHoverBack ? "grayscale(100%)": null }}
                    // className={isHover ? classes.hoverImageStyle : null}
                  />
                ) : (
                  false
                )}

                <CustomText
                  design={
                    isHoverFront || isHoverBack
                      ? classes.hoverDragDropTextStyle
                      : classes.dragDropTextStyle
                  }
                >
                  Drag and drop your file here or click to upload
                </CustomText>
              </div>
            </Grid>
          </Grid>
        </CustomPaper>
      )}
    </Files>
  );
};

const styles = (theme) => ({
  notUploadNRICPaper: {
    padding: theme.spacing(2),
    boxShadow: "0 0 0 0 rgba(0, 0, 0, 0)",
    borderRadius: 5,
    border: "dashed 2px #ced4da",
    marginTop: 8,
    marginBottom: 0,
    // [theme.breakpoints.down("xs")]: {
    //   minWidth: 250,
    //   maxWidth: 300,
    // },
    "&:hover": {
      color: "white",
      borderColor: Color.primaryColor,
      backgroundColor: Color.primaryColor,
    },
    cursor: "pointer",
  },
  notUploadNRICPaperisLogin: {
    padding: theme.spacing(2),
    boxShadow: "1px 1px 6px 0  rgba(0, 0, 0, 0.26)",
    borderRadius: 5,
    border: "solid 1px #fff",
    marginTop: 8,
    marginBottom: 0,
    // [theme.breakpoints.down("xs")]: {
    //   minWidth: 250,
    //   maxWidth: 300,
    // },
    "&:hover": {
      color: "white",
      borderColor: "#00B4AF",
      backgroundColor: "#00B4AF",
    },
    cursor: "pointer",
  },
  dragDropTextStyle: {
    textAlign: "center",
    marginLeft: 10,
  },
  hoverDragDropTextStyle: {
    textAlign: "center",
    marginLeft: 10,
    color: "white",
  },
});

export default withStyles(styles, { withTheme: true })(OpenFile);
